export abstract class UserConstants {
  public static readonly FIRST_NAME_MAX_LENGTH: number = 50;
  public static readonly LAST_NAME_MAX_LENGTH: number = 50;
  public static readonly DESCRIPTION_MIN_LENGTH: number = 1;
  public static readonly DESCRIPTION_MAX_LENGTH: number = 255;
  public static readonly DESCRIPTION_MAX_LENGTH_RAW: number = 1000;
  public static readonly EMAIL_MAX_LENGTH: number = 320;
  public static readonly EMAIL_PATTERN: RegExp = /^(.*).@(.*).\..+$/;
}
